import React, { useContext, useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { DirectoryContext } from '../../contexts/DirectoryContext'
import InputMask from 'react-input-mask';

import './NewListingForm.css'
import { Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup, Select, TextField, Button, MenuItem, InputLabel, FormControl, ButtonGroup, Input } from '@mui/material'
import { NewListingFormContext } from '../../contexts/NewListingFormContext'

import { useAuth } from '../../hooks/AuthProvider'

function NewListingForm() {

    const {
        errors,
        newListing,
        handleChange,
        handlePlanChange,
        handleListingTypeChange,
        handleSubmit,
        handleFileChange,
        showErrors,
        showLoading,
        showSuccess,
        apiResponseMessage,
    } = useContext(NewListingFormContext);

    const {
        stateOptions,
        countryOptions,
        listingPlans,
        categoryOptions,
        subCategoryOptions,
    } = useContext(DirectoryContext);

    const imageSrc = `data:image/jpeg;base64,${newListing.Picture}`;

    const auth = useAuth();
    const selectedPlan = listingPlans.find(p => p.Code == newListing.planOption);

    return (
        <div className='newlistingform-container'>
            <Form className='newlistingform-form'>
                <Row className='text-center mt-5'>
                    <Col>
                        <ButtonGroup className='newlistingform-buttongroup' variant='text'>
                            {
                                listingPlans.map((plan, index) => {
                                    return (
                                        <Button
                                            key={index}
                                            onClick={handlePlanChange}
                                            name='planOption'
                                            value={plan.Code}>
                                            {plan.Name}
                                        </Button>
                                    )
                                })
                            }
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h1>{selectedPlan?.Name} Plan Listing Information</h1>
                        <p>
                            Please enter the required (*) listing information below. Your request will then be processed
                            and you will be contacted for payment.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>Category Type*</InputLabel>
                            <Select
                                id='CategoryID'
                                name='CategoryID'
                                variant='filled'
                                label='Category ID'
                                margin='dense'
                                error={!!errors.CategoryID}
                                helpertext={errors.CategoryID}
                                value={newListing.CategoryID || ''}
                                onChange={handleListingTypeChange}>
                                {
                                    auth.user != null
                                        ? categoryOptions.map((category, index) => (
                                            <MenuItem
                                                key={index}
                                                value={category.ID}>
                                                {category.Name}
                                            </MenuItem>
                                        ))
                                        : categoryOptions
                                            .filter(category => category.ID === 1 || category.ID === 2 || category.ID === 3 || category.ID === 4)
                                            .map((category, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={category.ID}>
                                                    {category.Name}
                                                </MenuItem>
                                            ))
                                }
                            </Select>
                        </FormControl>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>Subcategory Type</InputLabel>
                            <Select
                                id='SubCategoryID'
                                name='SubCategoryID'
                                variant='filled'
                                label='SubCategoryID'
                                margin='dense'
                                error={!!errors.SubCategoryID}
                                helpertext={errors.SubCategoryID}
                                value={newListing.SubCategoryID || ''}
                                onChange={handleChange}>
                                {
                                    (subCategoryOptions || [])
                                        .filter(subcategory => subcategory.CategoryID === newListing.CategoryID)
                                        .map((subcategory, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={subcategory.ID}>
                                                    {subcategory.Name}
                                                </MenuItem>
                                            )
                                        })
                                }
                            </Select>
                        </FormControl>
                    </Col>
                </Row>
                {
                    ((['5', '6'].includes(newListing.CategoryID.toString())) ||
                        (['1'].includes(newListing.CategoryID.toString())) && (['2'].includes(newListing.SubCategoryID.toString()))) &&
                    <Row>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='FirstName'
                                name='FirstName'
                                label='First Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.FirstName}
                                helpertext={errors.FirstName}
                                value={newListing.FirstName || ''}
                                onChange={handleChange} />
                        </Col>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='LastName'
                                name='LastName'
                                label='Last Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.LastName}
                                helpertext={errors.LastName}
                                value={newListing.LastName || ''}
                                onChange={handleChange} />
                        </Col>
                    </Row>
                }
                {
                    ((['2', '3', '4'].includes(newListing.CategoryID.toString())) ||
                        (['1'].includes(newListing.CategoryID.toString())) && (['1'].includes(newListing.SubCategoryID.toString()))) &&
                    <Row>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='OrganizationName'
                                name='OrganizationName'
                                label='Organization Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.OrganizationName}
                                helpertext={errors.OrganizationName}
                                value={newListing.OrganizationName || ''}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='OwnerName'
                                name='OwnerName'
                                label='Owner Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.OwnerName}
                                helpertext={errors.OwnerName}
                                value={newListing.OwnerName || ''}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                }

                <Row>
                    <Col>
                        {
                            (newListing.CategoryID === 5 || newListing.CategoryID === 6) && !newListing.CustomerNumber
                                ? <TextField
                                    fullWidth={true}
                                    id='PositionTitle'
                                    name='PositionTitle'
                                    label='PositionTitle'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.PositionTitle}
                                    helperText={errors.PositionTitle}
                                    value={newListing.PositionTitle || ''}
                                    onChange={handleChange} />
                                : <TextField
                                    fullWidth={true}
                                    id='Prefix'
                                    name='Prefix'
                                    label='Prefix'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.Prefix}
                                    helperText={errors.Prefix}
                                    value={newListing.Prefix || ''}
                                    onChange={handleChange} />
                        }

                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='CustomerNumber'
                            name='CustomerNumber'
                            label='AJCA Customer Number*'
                            type='number'
                            variant='filled'
                            margin='dense'
                            error={!!errors.CustomerNumber}
                            helperText={errors.prefix}
                            value={
                                (newListing.CategoryID === 5 || newListing.CategoryID === 6) && !newListing.CustomerNumber
                                    ? newListing.CustomerNumber = '9999999'
                                    : newListing.CustomerNumber || ''
                            }
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={newListing.HomePhone || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='HomePhone'
                                    name='HomePhone'
                                    label='Home Phone'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.HomePhone}
                                    helpertext={errors.HomePhone}
                                />
                            )}
                        </InputMask>
                    </Col>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={newListing.WorkPhone || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='WorkPhone'
                                    name='WorkPhone'
                                    label='Work Phone'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.WorkPhone}
                                    helpertext={errors.WorkPhone}
                                />
                            )}
                        </InputMask>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={newListing.CellPhone || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='CellPhone'
                                    name='CellPhone'
                                    label='Cell Phone'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.CellPhone}
                                    helpertext={errors.CellPhone}
                                />
                            )}
                        </InputMask>
                    </Col>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={newListing.Fax || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='Fax'
                                    name='Fax'
                                    label='Fax'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.Fax}
                                    helpertext={errors.Fax}
                                />
                            )}
                        </InputMask>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Email'
                            name='Email'
                            label='Email'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.Email}
                            helpertext={errors.Email}
                            value={newListing.Email || ''}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <h3>Address</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>Country*</InputLabel>
                            <Select
                                fullWidth={true}
                                id='CountryID'
                                name='CountryID'
                                variant='filled'
                                label='CountryID'
                                margin='dense'
                                error={!!errors.CountryID}
                                helpertext={errors.CountryID}
                                value={newListing.CountryID || ''}
                                onChange={handleChange}>
                                {
                                    countryOptions.map((country, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={country.UnCode}>
                                                {country.Name}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='City'
                            name='City'
                            label='City*'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.City}
                            helperText={errors.City}
                            value={newListing.City || ''}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>State*</InputLabel>
                            <Select
                                fullWidth={true}
                                id='StateProvince'
                                name='StateProvince'
                                label='State'
                                variant='filled'
                                value={newListing.StateProvince || ''}
                                onChange={handleChange}>
                                <option>Select a State</option>
                                {
                                    stateOptions.map((state, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={state.Name}>
                                                {state.Name}
                                            </MenuItem>
                                        )
                                    })

                                }
                            </Select>
                        </FormControl>
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='ZipCode'
                            name='ZipCode'
                            label='Zip Code'
                            variant='filled'
                            type='number'
                            margin='dense'
                            error={!!errors.ZipCode}
                            helperText={errors.ZipCode}
                            value={newListing.ZipCode || ''}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Address1'
                            name='Address1'
                            label='Address Line 1'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.Address1}
                            helperText={errors.Address1}
                            value={newListing.Address1 || ''}
                            onChange={handleChange} />
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Address2'
                            name='Address2'
                            label='Address Line 2'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.Address2}
                            helperText={errors.Address2}
                            value={newListing.Address2 || ''}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>

                        <TextField
                            fullWidth={true}
                            id='LocationDescription'
                            name='LocationDescription'
                            label='Location Description'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.LocationDescription}
                            helpertext={errors.LocationDescription}
                            value={newListing.LocationDescription}
                            onChange={handleChange}
                            multiline={true}
                            rows={3} />
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <h3>Additional Options</h3>
                        <p>
                            Please give us any information about your listing that you would like us to know in the Notes section below.
                            This includes Logo specifications and desired listing plan information.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='CowCount'
                            name='CowCount'
                            label='Number Milking Cows'
                            type='number'
                            variant='filled'
                            margin='dense'
                            error={!!errors.CowCount}
                            helperText={errors.CowCount}
                            value={newListing.CowCount || ''}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='WebsiteUrl'
                            name='WebsiteUrl'
                            label='Website URL'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.WebsiteUrl}
                            helperText={errors.WebsiteUrl}
                            value={newListing.WebsiteUrl || ''}
                            onChange={handleChange} />
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='FacebookUrl'
                            name='FacebookUrl'
                            label='Facebook URL'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.FacebookUrl}
                            helperText={errors.FacebookUrl}
                            value={newListing.FacebookUrl || ''}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='LinkedInUrl'
                            name='LinkedInUrl'
                            label='LinkedIn URL'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.LinkedInUrl}
                            helperText={errors.LinkedInUrl}
                            value={newListing.LinkedInUrl || ''}
                            onChange={handleChange} />
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='InstagramUrl'
                            name='InstagramUrl'
                            label='Instagram URL'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.InstagramUrl}
                            helperText={errors.InstagramUrl}
                            value={newListing.InstagramUrl || ''}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='YoutubeUrl'
                            name='YoutubeUrl'
                            label='Youtube URL'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.YouTubeUrl}
                            helpertext={errors.YouTubeUrl}
                            value={newListing.YouTubeUrl}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>

                        <TextField
                            fullWidth={true}
                            id='FarmMessage'
                            name='FarmMessage'
                            label='Farm Message'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.FarmMessage}
                            helperText={errors.FarmMessage}
                            value={newListing.FarmMessage || ''}
                            onChange={handleChange}
                            multiline={true}
                            rows={3} />
                    </Col>

                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Notes'
                            name='Notes'
                            label='Notes'
                            type='text'
                            margin='dense'
                            variant='filled'
                            error={!!errors.Notes}
                            helperText={errors.Notes}
                            value={newListing.Notes || ''}
                            onChange={handleChange}
                            multiline={true}
                            rows={3} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <RadioGroup
                            value={newListing.PerformanceProgram || 'NONE'}
                            onChange={handleChange}
                            name="PerformanceProgram" >
                            <FormControlLabel value='NONE' control={<Radio />} label='None' />
                            <FormControlLabel value='REAP' control={<Radio />} label='REAP (Basic or Plus)' />
                            <FormControlLabel value='TPE' control={<Radio />} label='TPE (Basic or Plus)' />
                            <FormControlLabel value='FLAIR' control={<Radio />} label='FLAIR' />
                            <FormControlLabel value='PERF' control={<Radio />} label='Performance Records' />
                        </RadioGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox id='EquityInvestor' name='EquityInvestor' checked={newListing.EquityInvestor === true} onChange={handleChange} />}
                                label='Equity Investor'
                            />
                            <FormControlLabel
                                control={<Checkbox id='HeiferGrowerOnly' name='HeiferGrowerOnly' checked={newListing.HeiferGrowerOnly === true} onChange={handleChange} />}
                                label='Heifer Grower Only'
                            />
                            <FormControlLabel
                                control={<Checkbox id='IsActive' name='IsActive' checked={newListing.IsActive === true} onChange={handleChange} />}
                                label='Active Listing'
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Button variant="contained" component="label">
                                Upload File
                                <input
                                    type="file"
                                    onChange={handleFileChange}
                                    accept=".jpg,.jpeg"
                                    hidden 
                                />
                            </Button>
                            <p>Please enter a farm logo, or email it to journal and they will format and put it in for you.</p>
                            {newListing.Picture ? (
                                <div className='newListing-media'>
                                    <img
                                        height={300}
                                        width={450}
                                        src={imageSrc}
                                        alt="Uploaded farm logo"
                                    />
                                </div>
                            ) : (
                                <></>
                            )}
                            {errors.Picture && <p style={{ color: 'red' }}>{errors.Picture}</p>}
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-5'>
                    <Col>
                        <Button type="submit" variant='contained' onClick={handleSubmit}>
                            Submit
                        </Button>
                        {showSuccess && <p style={{ color: 'green' }}>Form submitted successfully!</p>}
                        {showErrors && (
                            <div>
                                <p style={{ color: 'red' }}>There were errors submitting the form:</p>
                                {Object.values(errors).filter(error => error !== '').map((error, index) => (
                                    <p key={index} style={{ color: 'red' }}>{error}</p>
                                ))}
                            </div>
                        )}
                        {showLoading && <p>Submitting...</p>}
                        {apiResponseMessage && <p>{apiResponseMessage}</p>}
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default NewListingForm